const LogList = () => import("~/components/Views/Prova/Relatorio/LogList");

import auth from "~/middleware/auth";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Relatórios", link: "" }
];

export const logs = [
  {
    path: "relatorios/logs",
    component: LogList,
    name: "Logs de Realização de Provas",
    meta: {
      title: "Logs de Realização de Provas",
      middleware: [auth, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/relatorio/logs.js